'use strict';
var url = require('url');

var checkParams = function(params, requiredParams) {
  var errorString, i;

  for(i = 0; i < requiredParams.length; i++) {
    if(! params[requiredParams[i]]) {
      errorString = 'Params must have a ' + requiredParams[i] + ' property';
      throw new Error(errorString);
    }
  }
};

var paymentURLs = {
  regular: function(productsObject) {
    productsObject.products = productsObject.products.toString();

    var urlObj = url.parse('initiate-payment/');
    urlObj.query = productsObject;
    return url.format(urlObj);
  },

  whitelabel: function(params) {
    checkParams(params, ['url', 'userId', 'partner']);

    var urlObj = url.parse(params.url);
    urlObj.query = {
      u: params.userId,
      p: params.partner.toUpperCase()
    };

    return url.format(urlObj);
  },

  whitelabelAddon: function(params) {
    checkParams(params, [
      'url',
      'userId',
      'partner',
      'action',
      'product'
    ]);

    var urlObj = url.parse(params.url);
    urlObj.query = {
      u: params.userId,
      p: params.partner.toUpperCase(),
      action: params.action,
      product: params.product
    };

    if(params.campaignID) {
      urlObj.query.campaignID = params.campaignID;
    }

    return url.format(urlObj);
  }
};

module.exports = paymentURLs;
